// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {FormGroup, ControlLabel, FormControl, HelpBlock} from 'ui'

function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel style={{fontSize:"0.8em"}}>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

export default FieldGroup;
